import * as faceapi from '@vladmandic/face-api';

let modelsLoaded = false;

export const initFaceApi = async () => {
  if (modelsLoaded) return true;
  
  try {
    // Use the correct model path
    const modelPath = '/models';
    console.log('Loading models from:', modelPath);
    
    // Load models in sequence with proper error handling
    try {
      console.log('Loading TinyFaceDetector...');
      await faceapi.nets.tinyFaceDetector.loadFromUri(modelPath);
      console.log('TinyFaceDetector loaded successfully');
    } catch (error) {
      console.error('Error loading TinyFaceDetector:', error);
      throw new Error(`Failed to load TinyFaceDetector: ${error.message}`);
    }
    
    try {
      console.log('Loading FaceLandmark68Net...');
      await faceapi.nets.faceLandmark68Net.loadFromUri(modelPath);
      console.log('FaceLandmark68Net loaded successfully');
    } catch (error) {
      console.error('Error loading FaceLandmark68Net:', error);
      throw new Error(`Failed to load FaceLandmark68Net: ${error.message}`);
    }
    
    try {
      console.log('Loading FaceRecognitionNet...');
      await faceapi.nets.faceRecognitionNet.loadFromUri(modelPath);
      console.log('FaceRecognitionNet loaded successfully');
    } catch (error) {
      console.error('Error loading FaceRecognitionNet:', error);
      throw new Error(`Failed to load FaceRecognitionNet: ${error.message}`);
    }
    
    modelsLoaded = true;
    console.log('All face-api models loaded successfully');
    return true;
  } catch (error) {
    console.error('Face-api model loading failed:', error);
    modelsLoaded = false;
    return false;
  }
};

// Initialize models immediately
initFaceApi().catch(error => {
  console.error('Initial face-api initialization failed:', error);
}); 